/**
 * @file useUpdateEffect
 * @author chenbo09
 */

import {useEffect, useRef, EffectCallback, DependencyList} from 'react';

export default (effect: EffectCallback, deps: DependencyList): void => {
    const isInitialMount = useRef(true);

    useEffect(() => {
        if (isInitialMount.current) {
            isInitialMount.current = false;
        }
        else {
            return effect();
        }
    }, deps);
};
